import { render, staticRenderFns } from "./oilBenzeneIndustrial.vue?vue&type=template&id=59b74b86&scoped=true&"
import script from "./oilBenzeneIndustrial.vue?vue&type=script&lang=js&"
export * from "./oilBenzeneIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./oilBenzeneIndustrial.vue?vue&type=style&index=0&id=59b74b86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b74b86",
  null
  
)

export default component.exports